<template>
  <div>
    <a-form :model="searchForm" :label-col="{ span: 3 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="8" :xl="7">
          <a-form-item label="品牌">
            <a-select v-model="searchForm.line_id" allowClear show-search option-filter-prop="children" placeholder="请选择" style="width: 100%">
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{
                item.org
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="reload" @click="handleAdd">更新平台</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right: 20px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </div>
    <!-- 表格 -->
    <a-table size="middle" row-key="id" :columns="columns" :loading="loading" :data-source="data" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <template slot="org" slot-scope="text">
        <a-tag color="blue">{{ text }}</a-tag>
      </template>
      <template slot="pinyin" slot-scope="text">
        {{ text + '.xml' }}
      </template>

      <template slot="operator" slot-scope="text, record">
        <a-button size="small" type="link" @click="lookArticle(record)">查看</a-button>
      </template>
    </a-table>
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { searchForm, columns } from './business/filialeList'
import pagination from '@/composables/pagination'
import api from '@/api/'

export default {
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      times: [],
      platformList: [],
      classifyList: [],
      searchForm: { ...searchForm }
    })

    onMounted(async () => {
      await methods.getPlatform()
      await methods.getArticleClassify()
      methods.getList()
    })

    const methods = {
      search() {
        _this.pagination.current = 1
        this.getList()
      },

      async getList() {
        _this.loading = true
        const res = await api.deadLinksBrandList({
          ..._this.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        const { die_link_brands, pagination } = res.data
        _this.data = die_link_brands
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data.filter(item => {
          return item.parent_id === 0
        })
      },

      // 获取文章分类
      async getArticleClassify() {
        const res = await api.listClassify()
        state.classifyList = res.data.articleType
      },

      // 刷新视图
      refreshView() {
        this.handleClear()
      },

      handleClear() {
        state.searchForm = { ...searchForm }
        state.times = []
        this.search()
      },
      async handleAdd() {
        const res = await api.deadLinksBrandUpdate()
        if (res.code === '000000') {
          _this.$message.success('更新成功')
          _this.getList()
        }
      },
      // 查看
      lookArticle(item) {
        _this.$router.push(`/deadLinks/lookArticle?project=${item.project}`)
      }
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...methods
    }
  }
}
</script>
